<template>
  <div class="payment-view">
    <section class="payment">
      <section class="payment-item billing-details" v-show="true">
        <div class="online-eftpos-container" :class="{'submitting' : submittingPayment }">
          <fieldset>
            <p><strong>Online EFTPOS</strong></p>
            <p>Pay directly from your smart phone banking app. Available to ANZ, ASB, BNZ, Westpac and The Co-operative Bank customers.</p>
            <div class="online-eftpos-container__form">

              <div class="columns is-vcentered mt-1">
                <div class="column is-4 has-text-centered-mobile">
                    <img class="icon-onlineeftpos" src="/assets/images/onlineeftpos.png" />
                </div>
                <div class="column is-8 is-narrow ">
                  <div class="columns is-multiline is-mobile is-centered is-vcentered-end">
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-bank" src="/assets/images/eftpos/anz.png" /></div>
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-bank" src="/assets/images/eftpos/asb.png" /></div>
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-bank" src="/assets/images/eftpos/bnz.png" /></div>
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-bank" src="/assets/images/eftpos/co-operative.png" /></div>
                      <div class="column is-narrow has-text-centered-mobile"><img class="icon-bank" src="/assets/images/eftpos/westpac.png" /></div>
                  </div>
                </div>
              </div>

              <!--      Pay from card on file   -->
              <div v-if="isAltFlow" class="columns">
                <div class="column">
                  <strong><InlineText
                      v-if="getAmountToPay > 0"
                      label="Payment required"
                      tooltip="This is the total additional premium to pay for the change to your policy."
                      />
                    <InlineText
                        v-if="getAmountToPay <= 0"
                        label="Refund"
                        tooltip="We will refund this back onto your credit card or bank account."
                      /></strong>
                  <p v-if="getAmountToPay >= 0">NZD {{ getAmountToPay|toCurrency }}</p>
                  <p v-else>NZD {{ (getAmountToPay*-1)|toCurrency }}</p>
                </div>
                <div class="column has-text-right is-hidden-mobile">
                  
                </div>
              </div>

            </div>

          </fieldset>
        </div>
      </section>
    </section>

    <div class="box" v-if="envNotProd">
      DEBUG
      <div class="field is-horizontal mt-5">
        <div class="field-label is-normal">
          <label class="label ">$</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control">
              <input class="input" type="text" v-model="customPaymentAmount" placeholder="2.01" />
            </p>
          </div>
        </div>
        
        <button v-on:click="customPayment = customPaymentAmount;" class="button" :class="(customPayment ? 'is-warning' : 'is-outlined is-disabled')">Custom Payment<template v-if="customPayment"> (${{ customPayment }})</template></button>
        <button v-if="customPayment" v-on:click="customPayment = null;" class="button is-danger">Remove custom payment amount</button>
      </div>
      <div class="">
        <div class="">
            <button v-on:click="toggleFprnTestState()" class="button" :class="(fprnTest ? 'is-warning': 'is-outlined is-disabled')">Test FPRN</button>
        </div>
        <br />
        <div class="" v-if="fprnTest">
          <p>On successful payment, will not redirect back to success page, which allows FPRN to complete payment in background</p>
        </div>
      </div>
    </div>

    <section class="notification is-warning mt-5" v-show="this.errors">
      {{ errors }}
    </section>
    <section class="notification is-success mt-5" v-show="this.paymentSuccess">
      successful, confirming policy...
    </section>
  </div>
</template>

<script>

import Vue from 'vue';
import axios from 'axios';
import { mapGetters } from 'vuex'
import store, { api } from '../../store/store.js';

export default {
  name: 'Payment',
  data() {
    return {
      card: null,
      elementsError: null,
      submittingPayment: true,
      paymentErrors: [],
      paymentSuccess: false,
      modalOpen: false,
      txnid: null,
      customPaymentAmount: null,
      customPayment: null,
      fprnTest: null,
      errors: null,
    };
  },
  created() {

    /* set everything given a cookie */

    let override_pricing_cookie_name = 'ONLINE_EFTPOS_CUSTOM_AMOUNT'
    let fprn_test_cookie_name = 'ONLINE_EFTPOS_FPRN_TEST'

    let customPaymentAmount = document.cookie.match('(^|;)?' + override_pricing_cookie_name + '=([^;]*)(;|$)');
    let fprnTest = document.cookie.match('(^|;)?' + fprn_test_cookie_name + '=([^;]*)(;|$)');

    this.customPaymentAmount = customPaymentAmount[2] ?? null;
    this.fprnTest = fprnTest[2] ?? null;

    if (this.customPaymentAmount !== null) {
      this.customPayment = this.customPaymentAmount;
    }


  },
  beforeDestroy() {
    
  },
  computed: {
    console: () => console,

    getAmountToPay: function(){
      if( "vehicle_quote_adjustment_raw" in this.answers[this.getStep('Vehicle.Quote')] ){
        this.$emit('get-amount-to-pay', this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw);
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw;
      } else {
        this.$emit('get-amount-to-pay', this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw);
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw;
      }
    },
    dynamicIframeHeight: function(){
      let viewportHeight = window.innerHeight;
      if( viewportHeight >= 1100 ){
        return 1100;
      } else if ( viewportHeight > 500 ){
        return viewportHeight - 100;
      }
      // Max height for mobile
      return 470;
    },
    ...mapGetters({
      client: 'client',
      answers: 'flattenedAnswers',
      schemaHash: 'getSessionSchemaHash',
      getStep: 'getStep',
      isAltFlow: 'isAltFlow',
      isRenewFlow: 'isRenewFlow',
      envNotProd: 'envNotProd'
    }),
  },
  watch: {
    customPayment: (customPaymentAmount) => {
      axios.post(`/payment-processor/test-custom-amount/onlineeftpos`, { amount: customPaymentAmount } )
        .then(response => {
          // all good
        }, error => {
          console.error("Problem setting cookie for custom payment amount for online eftpos.");
        });

    },
    fprnTest: (state) => {
      axios.post(`/payment-processor/test-disable-customer-return/onlineeftpos`, { disable: state } )
        .then(response => {
          // all good
        }, error => {
          console.error("Problem setting cookie for fprn test for online eftpos.");
        });

    }
  },
  methods: {
      // When this.fprnTest changes state, the watch picks up and changes the cookie value each time 
      toggleFprnTestState (){
          if (this.fprnTest) { 
              this.fprnTest = null 
          } else { 
              this.fprnTest = true 
          }
      }
  },
};
</script>

<style scoped lang="scss">

.icon-onlineeftpos {
  width: 140px;
  margin-right: 5px;
}
.icon-bank {
    max-height: 48px;
    max-width: 48px;
}

</style>
